<template>
  <div>
    <div class="label-template text-left mb-4">
      {{ categorySelected.PresentationsCategories.length }} {{ $i18nPresenter.t("templates") }}
    </div>
    <div class="category-result-section">
      <TemplateCard
        class="mb-6"
        v-for="itemCategory in categorySelected.PresentationsCategories"
        :key="itemCategory.id"
        :presentation="itemCategory.Presentation"
      />
    </div>
  </div>
</template>
<script>
// This component is DEPRECATED.
//
// **Related Issue:**
// Organizing Template Library by Primary Use Cases
// (https://ahaslides.atlassian.net/browse/AHA-28934) (Feature: F)
//
// **Feature Flag:**
// release-reorganising-template-library
//
// **Removal Conditions:**
// - The feature (F) is 100% live.
// - The feature flag is fully enabled.
// - The EU environment is no longer frozen
//   (details: https://ahaslides.atlassian.net/browse/AHA-30247).
//
// **Replacement:**
// Use "@/components-v2/template-library/v2/template-container/CategoryResultSection.vue" instead.
//
// TODO: Remove this file once all the above conditions are met.

import TemplateCard from './TemplateCard.vue'

export default {
  components: {
    TemplateCard,
  },
  props: {
    categorySelected: {
      type: Object,
      default: () => {
        return {
          PresentationsCategories: [],
        }
      },
    },
  },
  data() {
    return {

    }
  },
}
</script>
<style scoped lang='scss'>
.category-result-section {

  @media (max-width: 1024px) {
    &::v-deep {
      .template-card {
        width: 100%;
        margin-right: 0;
      }
    }
  }
}
</style>
